import React from "react";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
  searchedData?: any;
}

const Heading2: React.FC<Heading2Props> = ({ className = "", subHeading }) => {
  const storedSearchData = useSelector(
    (state: RootState) => state.search.searchedData
  );
  const { startDate, endDate, totalGuests, searchedResult, locationData } =
    storedSearchData || {};
  const propertiesCount = searchedResult?.total_count;
  const city = locationData?.city;
  const heading = city ? `Stays in ${city}` : "";
  
  const formatDate = (date: Date | string | undefined) => {
    if (!date) return "";
    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
    };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  return (
    <div className={`mb-3 ${className}`}>
      <h2 className="text-base sm:text-lg font-medium text-gray-700 dark:text-gray-300">
        {heading}
      </h2>
      {subHeading ? (
        subHeading
      ) : (
        propertiesCount > 0 && (
          <div className="flex items-center flex-wrap gap-1 text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1">
            {formattedStartDate && formattedEndDate && (
              <>
                <span>{formattedStartDate} - {formattedEndDate}</span>
                <span>·</span>
              </>
            )}
            {totalGuests && (
              <span>{totalGuests} {totalGuests === 1 ? "Guest" : "Guests"}</span>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Heading2;